__turbopack_context__.v({
  "dark": "W2A4zG_dark",
  "light": "W2A4zG_light",
  "loader": "W2A4zG_loader",
  "rotation": "W2A4zG_rotation",
});
